import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/** Whether the Scout skills library (slash menu, Manage Skills) is on for this user. */
export function useScoutSkillsLibraryEnabled(): boolean {
  const { featureFlags } = useFeatureFlags();
  return Boolean(featureFlags[FeatureFlagKey.ScoutSkillsLibrary]);
}
